import { render, staticRenderFns } from "./FooterSeoSection.vue?vue&type=template&id=cb2b3f7c&"
import script from "./FooterSeoSection.vue?vue&type=script&lang=js&"
export * from "./FooterSeoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports